import { t } from '../lib/i18n';

/**
 * What came back on `?sso_erro=`.
 *
 * The API redirects with a code and never a sentence (context.md §130), so the wording lives here.
 * An unrecognised code gets the generic message rather than being shown raw: it arrives in a query
 * string, which means it arrives from outside.
 */
const MESSAGES: Record<string, string> = {
  provider_refused: 'sso.error.providerRefused',
  invalid_callback: 'sso.error.invalidCallback',
  'auth.sso_state_unknown': 'sso.error.expired',
  'auth.sso_connection_changed': 'sso.error.changed',
  'auth.sso_rejected': 'sso.error.rejected',
  'auth.sso_domain_not_allowed': 'sso.error.domainNotAllowed',
  'auth.sso_unverified_email': 'sso.error.unverifiedEmail',
  'auth.sso_no_account': 'sso.error.noAccount',
  'auth.account_disabled': 'sso.error.accountDisabled',
  'sso_connection.not_found': 'sso.error.notFound',
};

export function ssoErrorMessage(code: string | null): string | null {
  if (!code) return null;

  const key = MESSAGES[code];

  return key ? t(key) : t('sso.error.generic');
}
